import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import DataRepository from '../../app/data-framework/data-repository';
import DataProvider from '../../app/data-framework/data-provider';
import templateMarkup from 'raw-loader!./updateroom-modal.html';
import '../../app/bindings/ko-bindinghandler-tokenfield';



    function UpdateRoom(params) {
        let self = this;
        self.signals = ko.unwrap(params.signals);

        if (!_.has(self, 'signals.onShow') || !_.has(self, 'signals.onSave')) {
            throw new Error('UpdateRoom:: Missing required signals: show, save');
        }
        this.signals.onShow.add(_.bind(this.show, this));
        this.signals.onSave.add(_.bind(this.save, this));

        this.dataRepository = DataRepository.getInstance();
        this.dataProvider = DataProvider.getInstance();

        this.id = ko.observable();
        this.roomName = ko.observable('');
        this.endpoints = ko.observableArray();

        this.updateError = ko.observable();
        this.hasUpdateError = ko.pureComputed(_.bind(function() {
            return !_.isEmpty(this.updateError());
        }, this));

        // endpoint selection
        this.noSelection = [{ id: null, name: '<No Assigned Endpoint>' }];

        this.availableEndpoints = ko.observableArray();

        this.assignedEndpoint = ko.observable();
        this.endpointMultiSelectOptions = {
            includeSelectAllOption: false,
            nonSelectedText: '<No Assigned Endpoint>',
            enableFiltering: true,
            enableCaseInsensitiveFiltering: true,
            maxHeight: 400,
            disabledText: 'Loading endpoints...',
            disableIfEmpty: true,
            onChange: this.clearFilter
        };

        this.saveCallback = null;
    }

    UpdateRoom.prototype.clearFilter = function() {
        var $queryInputElem = $('#endpointMultiSelect ~ div.btn-group ul li.multiselect-item.filter input');
        var query = $queryInputElem.val();
        if (query) {
            $queryInputElem.val('').trigger('keydown');
        }
    };

    /**
     * Shows the Edit Room modal.
     *
     * @param {object} model Room model. An object with
     * the following properties.
     *
     * id, ids (for batch edit), name, endpoints, location, tagNames
     */
    UpdateRoom.prototype.show = function(model) {
        if (!_.has(model, 'id')) {
            throw new Error('UpdateRoom needs an endpoint model with an id.');
        }
        this.id(model.id);
        this.roomName(model.name || '');
        this.updateError(null);

        // set the list of available endpoints
        var endpointList = this.dataRepository.listOfEndpointsWithIdsObservable();
        this.availableEndpoints(_.isEmpty(endpointList) ? [] : _.concat(this.noSelection, endpointList));

        // model contains endpoints array but we only allow a single endpoint to be assigned at this moment
        this.assignedEndpoint(_.isEmpty(_.get(model, 'endpoints')) ? null : String(model.endpoints[0].id));

        this.saveCallback = model.saveCallback || null;

        $("#UpdateRoom").modal('show');
    };

    UpdateRoom.prototype.save = function() {
        this.dataProvider.updateRooms([{
            id: this.id(),
            endpoints: _.isNil(this.assignedEndpoint()) ? [] : [this.assignedEndpoint()]
        }]).then(_.bind(function() {
            this.signals.closeModal.dispatch();
            this.saveCallback();
        }, this))
        .catch(_.bind(function(error, statusCode) {
            if (statusCode === 422 /*Unprocessable Entity*/) {
                // API returns 422 when endpoint is already assigned to another room
                this.updateError('This endpoint is already assigned to another room.');
            }
            else {
                this.updateError('There was an error saving the room details.');
            }
        }, this));
    };

    UpdateRoom.prototype.dispose = function() {
        this.signals.onShow.dispose();
        this.signals.onSave.dispose();
    };

    export default { viewModel: UpdateRoom, template: templateMarkup };
